var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25742 3.42088C7.52598 2.74831 6.56858 2.37503 5.57492 2.375C5.04899 2.37555 4.52835 2.4801 4.04298 2.68263C3.55761 2.88517 3.11708 3.18169 2.74675 3.55514C1.16719 5.14141 1.16786 7.62252 2.74809 9.20208L7.67004 14.124C7.78416 14.3247 8.00434 14.4543 8.25742 14.4543C8.36134 14.4533 8.46357 14.4279 8.5559 14.3802C8.64824 14.3326 8.72811 14.2639 8.78909 14.1797L13.7668 9.20208C15.347 7.62185 15.347 5.14141 13.7654 3.55245C13.3953 3.17969 12.9551 2.88377 12.4702 2.6817C11.9853 2.47963 11.4652 2.3754 10.9399 2.375C9.94629 2.37516 8.98894 2.74842 8.25742 3.42088ZM12.8162 4.50167C13.8654 5.55627 13.8661 7.20364 12.8175 8.25287L8.25742 12.813L3.69731 8.25287C2.64874 7.20364 2.64941 5.55627 3.69596 4.50435C4.20615 3.99685 4.87342 3.71759 5.57492 3.71759C6.27643 3.71759 6.94101 3.99685 7.44717 4.50301L7.78282 4.83866C7.8451 4.90105 7.91908 4.95055 8.00052 4.98432C8.08196 5.0181 8.16926 5.03548 8.25742 5.03548C8.34559 5.03548 8.43288 5.0181 8.51432 4.98432C8.59576 4.95055 8.66974 4.90105 8.73203 4.83866L9.06768 4.50301C10.0827 3.49002 11.8025 3.49271 12.8162 4.50167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxHeart);
export default __webpack_public_path__ + "static/media/bx-heart.bf0ca2a50324f0553967ade83fcd85f4.svg";
export { ForwardRef as ReactComponent };